// checkoutActions.js








export const SET_ADDRESS_DATA_CURRENT = 'SET_ADDRESS_DATA_CURRENT';
export const SET_PAYADDRESS_DATA_CURRENT = 'SET_PAYADDRESS_DATA_CURRENT';


export const SET_ORDERDATA_SELECTED = 'SET_ORDERDATA_SELECTED';
export const SET_PAYMENTDATA_SELECTED = 'SET_PAYMENTDATA_SELECTED';
export const SET_PAYMENTMOLLIEINSTANCE_SELECTED = 'SET_PAYMENTMOLLIEINSTANCE_SELECTED';

export const SET_SHIPPINGDATA_SELECTED = 'SET_SHIPPINGDATA_SELECTED';
export const SET_PICKUPDATA_SELECTED = 'SET_PICKUPDATA_SELECTED';
export const SET_SHIPORDELIVERDATA_SELECTED = 'SET_SHIPORDELIVERDATA_SELECTED';
export const SET_DELIVERORPAYADDRESSDATA_SELECTED = 'SET_DELIVERORPAYADDRESSDATA_SELECTED';
export const SET_ADDITIONALFORMINPUT_SELECTED = 'SET_ADDITIONALFORMINPUT_SELECTED';

// -------------------------------- INITIAL 


export const SET_CHECKOUTCONTEXTINITIAL_DATA = 'SET_CHECKOUTCONTEXTINITIAL_DATA';

export const SET_ALLCHECKOUTCONTEXT_DATA = 'SET_ALLCHECKOUTCONTEXT_DATA';
export const SET_PAYMENTINITIAL_METHODS = 'SET_PAYMENTINITIAL_METHODS';
export const SET_BILLINGADDRESSINITIAL_DATA = 'SET_BILLINGADDRESSINITIAL_DATA';
export const SET_SHIPPINGADDRESSINITIAL_DATA = 'SET_SHIPPINGADDRESSINITIAL_DATA';
export const SET_PICKUPLOCATIONSINITIAL_DATA = 'SET_PICKUPLOCATIONSINITIAL_DATA';

// -------------------------------- SELECT


export const SET_ALLCHECKOUTCONTEXTSELECT_DATA = 'SET_ALLCHECKOUTCONTEXTSELECT_DATA';

export const SET_PAYMENTSELECT_METHODS = 'SET_PAYMENTSELECT_METHODS';
export const SET_BILLINGADDRESSSELECT_DATA = 'SET_BILLINGADDRESSSELECT_DATA';
export const SET_SHIPPINGADDRESSSELECT_DATA = 'SET_SHIPPINGADDRESSSELECT_DATA';
export const SET_PICKUPLOCATIONSSELECT_DATA = 'SET_PICKUPLOCATIONSSELECT_DATA';
export const SET_SELECTUSER_DATA = 'SET_SELECTUSER_DATA';







//******************************************************************* */


export const setAllCheckoutContext = (checkoutcontextall) => {
  return {
    type: SET_ALLCHECKOUTCONTEXT_DATA,
    payload: checkoutcontextall
  };
};



export const setCheckoutContextInitial = (checkoutinitialcontext) => {
  return {
    type: SET_CHECKOUTCONTEXTINITIAL_DATA,
    payload: checkoutinitialcontext
  };
};

export const setInitialPaymentMethods = (initialpaymentmethod) => ({
  type: SET_PAYMENTINITIAL_METHODS,
  payload: initialpaymentmethod
});

export const setInitialBillingAddress = (initialbillingaddress) => ({
  type: SET_BILLINGADDRESSINITIAL_DATA,
  payload: initialbillingaddress
});

export const setInitialShippingAddress = (initialshippingaddress) => ({
  type: SET_SHIPPINGADDRESSINITIAL_DATA,
  payload: initialshippingaddress
});

export const setInitialPickuplocations = (initialpickuplocations) => ({
  type: SET_PICKUPLOCATIONSINITIAL_DATA,
  payload: initialpickuplocations
});

//******************************************************************* */



export const setAllCheckoutContextSelect = (checkoutselectcontext) => {
  return {
    type: SET_ALLCHECKOUTCONTEXTSELECT_DATA,
    payload: checkoutselectcontext
  };
};

export const setSelectPaymentMethods = (selectpaymentmethod) => ({
  type: SET_PAYMENTSELECT_METHODS,
  payload: selectpaymentmethod
});

export const setSelectBillingAddress = (selectbillingaddress) => ({
  type: SET_BILLINGADDRESSSELECT_DATA,
  payload: selectbillingaddress
});

export const setSelectShippingAddress = (selectshippingaddress) => ({
  type: SET_SHIPPINGADDRESSSELECT_DATA,
  payload: selectshippingaddress
});

export const setSelectPickuplocations = (selectpickuplocations) => ({
  type: SET_PICKUPLOCATIONSSELECT_DATA,
  payload: selectpickuplocations
});

export const setSelectUserdata = (selectuserdata) => ({
  type: SET_SELECTUSER_DATA,
  payload: selectuserdata
});




//-------------------------------------------------------------------









export const setAddressData = (addressData) => ({
  type: SET_ADDRESS_DATA_CURRENT,
  payload: addressData
});



export const setSelectedOrderData = (orderdata) => ({
  type: SET_ORDERDATA_SELECTED,
  payload: orderdata
});

export const setSelectedPaymentData = (paymentdata) => ({
  type: SET_PAYMENTDATA_SELECTED,
  payload: paymentdata
});

export const setSelectedPaymentMollieInstance = (paymentmollieinstance) => ({
  type: SET_PAYMENTMOLLIEINSTANCE_SELECTED,
  payload: paymentmollieinstance
});

export const setSelectedShippingData = (shippingdata) => ({
  type: SET_SHIPPINGDATA_SELECTED,
  payload: shippingdata
});

export const setSelectedPickupData = (pickupdata) => ({
  type: SET_PICKUPDATA_SELECTED,
  payload: pickupdata
});

export const setSelectedShipOrDeliverData = (shipordeliverdata) => ({
  type: SET_SHIPORDELIVERDATA_SELECTED,
  payload: shipordeliverdata
});

export const setSelectedDeliverorPayAddressData = (deliverorpayaddressdata) => ({
  type: SET_DELIVERORPAYADDRESSDATA_SELECTED,
  payload: deliverorpayaddressdata
});

export const setSelectedAdditionalFormInputData = (additionalforminputdata) => ({
  type: SET_ADDITIONALFORMINPUT_SELECTED,
  payload: additionalforminputdata
});

